import type { ChangeEvent, FunctionComponent } from 'react';
import { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDebouncedCallback } from 'use-debounce';

import styles from './WorkspaceMembersFilterBox.less';

interface WorkspaceMembersFilterBoxProps {
  onNameFilterChange: (value: string) => void;
}

export const WorkspaceMembersFilterBox: FunctionComponent<
  WorkspaceMembersFilterBoxProps
> = ({ onNameFilterChange }) => {
  const [nameFilterValue, setNameFilterValue] = useState('');

  const handleNameFilterChange = useDebouncedCallback(onNameFilterChange, 100);

  const onChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setNameFilterValue(e.target.value);
      handleNameFilterChange(e.target.value);
    },
    [handleNameFilterChange],
  );

  const intl = useIntl();

  return (
    <div>
      <input
        className={styles.searchInput}
        type="text"
        placeholder={intl.formatMessage({
          id: 'templates.org_members.filter-by-name',
          defaultMessage: 'Filter by name',
          description:
            'Allows filtering organization members list by their names.',
        })}
        value={nameFilterValue}
        onChange={onChange}
      />
    </div>
  );
};
